import * as React from 'react'


type Props = {
  className?: string
}

const TerminalHeuristicsTable: React.FC<Props> = ({ className = '' }) => {
  const tableHeaderClasses = 'text-left pr-4 text-gray-700 font-normal text-xs uppercase py-2 pl-2 border-b bg-gray-100';
  const tableRowClasses = 'hover:bg-gray-100 border-b text-xs';
  const tableCellClasses = 'pr-4 pl-2 py-2 ';
  const criteriaCellClasses = 'text-gray-600';
  return (
    <div className={' ' + className}>
        <table className="w-full">
          <thead className="">
            <tr className="">
              <th className={tableHeaderClasses + ' rounded-tl'}>
                Node heuristic
              </th>
              <th className={tableHeaderClasses + ' rounded-tr'}>
                Criteria
              </th>
            </tr>
          </thead>

          <tbody>

            <tr className={tableRowClasses}>
              <td className={tableCellClasses }>
                Channel disable ratio
              </td>
              <td className={tableCellClasses + ' ' + criteriaCellClasses}>
                Less than 25%
              </td>
            </tr>
            <tr className={tableRowClasses}>
              <td className={tableCellClasses}>
                Active channels
              </td>
              <td className={tableCellClasses  + ' ' + criteriaCellClasses}>
                More than 10 channels
              </td>
            </tr>
            <tr className={tableRowClasses}>
              <td className={tableCellClasses}>
                Median channel capacity
              </td>
              <td className={tableCellClasses  + ' ' + criteriaCellClasses}>
                More than 500,000 satoshi
              </td>
            </tr>
            <tr className={tableRowClasses}>
              <td className={tableCellClasses}>
                Uptime ratio
              </td>
              <td className={tableCellClasses  + ' ' + criteriaCellClasses}>
                More than 99.9%
              </td>
            </tr>
            <tr className={tableRowClasses}>
              <td className={tableCellClasses}>
                Good inbound peer
              </td>
              <td className={tableCellClasses  + ' ' + criteriaCellClasses}>
                More than 1 peer
              </td>
            </tr>
            <tr className={tableRowClasses}>
              <td className={tableCellClasses}>
                Good outbound peer
              </td>
              <td className={tableCellClasses  + ' ' + criteriaCellClasses}>
                More than 2 peers
              </td>
            </tr>
          </tbody>

        </table>
    </div>
  );
}

export default TerminalHeuristicsTable;

